import { style } from 'typestyle'
import { important } from 'csx'
export const f18i = style({ fontSize: important('18px') })
